import { render, staticRenderFns } from "./FormDepartment.vue?vue&type=template&id=ecd5354e&"
import script from "./FormDepartment.vue?vue&type=script&lang=js&"
export * from "./FormDepartment.vue?vue&type=script&lang=js&"
import style0 from "./FormDepartment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports